<!--
 * @Author: xiehangyi
 * @LastEditors: xiehangyi
 * @Description: excel导出
-->
<template>
  <el-button
    class="lc-excel-export"
    v-bind="$attrs"
    :loading="isShowLoading"
    @click="handleDownload"
  >
    <template v-if="iconPosition === 'right'">
      {{ label }}
    </template>
    <slot v-if="isShowIcon"></slot>
    <!-- <component
      :is="isShowIcon && comp.componentName"
      v-for="comp in reChildren"
      :key="comp.id"
      v-bind="comp.props"
    /> -->
    <template v-if="iconPosition === 'left'">
      {{ label }}
    </template>
  </el-button>
</template>

<script>
import { request } from '@/apis/request'
import { downloadFile } from '@/utils/common.js'

export default {
  name: 'LcExcelExport',
  props: {
    // 内容
    label: {
      type: String,
      default: ''
    },
    // 导出的url
    action: {
      type: String,
      default: ''
    },
    // 导出url请求类型
    method: {
      type: String,
      default: 'GET'
    },
    // 导出的请求头部
    headers: {
      type: Object,
      default: () => ({})
    },
    // 导出附带的额外参数
    data: {
      type: Object,
      default: () => ({})
    },
    // 设置导出请求的返回数据类型
    responseType: {
      type: String,
      default: 'APPLICATION/JSON'
    },
    isShowIcon: {
      type: Boolean,
      default: true
    },
    iconPosition: {
      type: String,
      default: 'left'
    },
  },
  data() {
    return {
      isShowLoading: false
    };
  },
  created() {
    // preset
  },
  mounted() {
    // preset
  },
  methods: {
    // 文件下载
    async handleDownload() {
      if(!this.action) {
        this.$message.info('暂无可用的下载路径')
        return
      }
      try {
        const res = await request({
          url: this.action,
          method: this.method,
          headers: this.headers,
          params: this.data,
          data: this.data,
          responseType: this.responseType
        });
        downloadFile(res)
      } catch (error) {
        console.error(error)
      }
    }
  }
};
</script>
